import {
  Component,
  AfterContentChecked
} from '@angular/core';

import {
  SkyModalService,
  SkyModalCloseArgs
} from '../../core';

import {
  SkySectionedModalFormDemoComponent
} from './sectioned-modal-form-demo.component';


export class SkySectionedFormDemoComponent implements AfterContentChecked {
  public activeIndexDisplay: number;
  private _activeIndex: number;

  constructor(private modal: SkyModalService) { }

  public openModal() {
    let modalInstance = this.modal.open(SkySectionedModalFormDemoComponent);

    modalInstance.closed.subscribe((result: SkyModalCloseArgs) => {
      if (result.reason === 'cancel') {
        console.log(`Modal cancelled with data ${result.data}`);
      } else if (result.reason === 'save') {
        console.log(`Modal saved with data ${result.data}`);
      }
    });
  }

  public ngAfterContentChecked() {
    this.activeIndexDisplay = this._activeIndex;
  }

  public updateIndex(newIndex: number) {
    this._activeIndex = newIndex;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-sectioned-form-demo',
  template: `<h3>Sectioned form — Index: {{ activeIndexDisplay }}</h3>
<div style="height: 150px;">
  <sky-sectioned-form (indexChanged)="updateIndex($event)" >
    <sky-sectioned-form-section heading="Basic information">
      <sky-demo-information-form>
      </sky-demo-information-form>
    </sky-sectioned-form-section>
    <sky-sectioned-form-section heading="Addresses" itemCount="2" active="true">
      <sky-demo-address-form></sky-demo-address-form>
    </sky-sectioned-form-section>
    <sky-sectioned-form-section heading="Phone numbers" itemCount="3">
      <sky-demo-phone-form></sky-demo-phone-form>
    </sky-sectioned-form-section>
  </sky-sectioned-form>
</div>

<h3>With a modal</h3>
<button type="button" class="sky-btn sky-btn-default" (click)="openModal()">
  Open sectioned form
</button>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
